<template>
	<div>
		<table class="table">
			<tbody>
				<tr>
					<td>Client</td>
					<td>{{ booking.client.name }}</td>
				</tr>
				<tr>
					<td><strong>Location</strong></td>
					<td>{{ booking.address }}, {{ booking.suburb.name }}</td>
				</tr>
				<tr>
					<td><strong>Type</strong></td>
					<td>
						Fill-in Service(s)
					</td>
				</tr>
				<tr>
					<td><strong>Hours</strong></td>
					<td>{{ booking.hours }} Hours</td>
				</tr>
				<tr v-if="booking.service !== 'Oneoff'">
					<td><strong>Products Required</strong></td>
					<td>{{ booking.requires_products ? 'Yes' : 'No' }}</td>
				</tr>
				<tr v-if="booking.service !== 'Oneoff'">
					<td><strong>Equipment Required</strong></td>
					<td>{{ booking.requires_equipment ? 'Yes' : 'No' }}</td>
				</tr>
				<tr>
					<td><strong>Rate</strong></td>
					<td>${{ booking.hourly_rate }}</td>
				</tr>
				<tr>
					<td><strong>Notes</strong></td>
					<td>
						<template
							v-for="service in services"
							style="word-wrap: anywhere;">
							<template v-if="service.job_offer_notes">
								<p :key="`${service.id}-notes`">
									<strong>{{ moment(service.date).format('DD/MM/YYYY') }}</strong><br>{{ service.job_offer_notes }}
								</p>
							</template>
						</template>

						<template v-if="booking.type === 'Commercial'">
							This is an insurance/NDIS service and you will be paid by the Agency
							weekly. You will receive instructions on how you will be paid.
						</template>
					</td>
				</tr>
				<tr>
					<td>
						<strong>Date(s)</strong>
					</td>
					<td>
						<BBadge
							v-for="service in services"
							:key="service.id"
							variant="primary"
							class="mr-2 p-2">
							{{ moment(service.date).format('DD/MM/YYYY') }}
						</BBadge>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
	export default {
		name: 'JobOfferService',
		props: {
			offer: {
				type: Object,
				required: true
			}
		},
		computed: {
			services() {
				return this.offer.services
			},
			booking() {
				return this.offer.booking
			},
		}
	}
</script>

<style scoped>

</style>
